module.exports = __webpack_public_path__ + "productivity1.png?19a7a5bc0208b43ef72ec6119057c2ad";